class QueryParams {
  static getQueryParam(name: string): string | null {
    const queryString = window.location.search;

    if (queryString) {
      const urlParams = new URLSearchParams(queryString);
      return urlParams.get(name);
    }
    return null;
  }

  static getAllQueryParams(): Record<string, string | null> {
    const queryString = window.location.search;

    if (queryString) {
      return Object.fromEntries(new URLSearchParams(queryString));
    }
    return {};
  }
}

export default QueryParams;
